//components
import {BasicButton} from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';

//styling
import "../../../../../css/global/Modals/passkey-data-modal.scss";



const WhitelistRestrictionModal = ({whitelistIsEnabled, showModal, hideModal, onConfirmClick} : {whitelistIsEnabled: boolean, showModal: boolean, hideModal: () => void, onConfirmClick: ()=>void}) => {
    if (!showModal) return <></>;

    return (
        <>
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="whitelist-restriction-modal" 
            isFullPage
        >
                <div className="whitelist-restriction-modal-content">
                     <h1 className='header-text'>{whitelistIsEnabled ? "Remove IP Whitelist" : "Enable IP Whitelist"}</h1> 
            
                    <div>
                        {whitelistIsEnabled
                            ?   "This will allow account recovery requests and sign-in codes from any device or location, not just the IP addresses you’ve added. Are you sure you want to disable this restriction?"
                            :   "This will restrict account recovery requests and the use of sign-in codes from another device to only allow access from manually added IP addresses. Are you sure you want to enable this restriction?"
                        }
                    </div>

                    <div className='modal-button-panel'>
                        <BasicButton 
                            content={"Confirm"}  
                            className={`confirm-button ${whitelistIsEnabled ? "alert-style" : "thrive-navy-style"}`}  
                            ariaLabel={'Confirm'} 
                            onButtonClick={onConfirmClick}
                        />
                    </div>
                </div>
        </ModalWrapper> 
        </>
    );  
}

export default WhitelistRestrictionModal;
